import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../Confg/UserContext';
import { motion } from 'framer-motion';

const ProtectedRoute = ({ children, requireMerchant = false, requireAdmin = false }) => {
    const { user, authLoading, isMerchant, isAdmin, resolvedUid } = useUser();
    const location = useLocation();

    // Aguarda a auth E a resolução do merchant/user para o uid atual antes de
    // decidir. Sem isso, logo após autenticar o status ainda é desconhecido
    // (a busca roda depois deste render) e o usuário era redirecionado de volta
    // ao login indevidamente. Comparar com resolvedUid elimina essa corrida.
    if (authLoading || (user && resolvedUid !== user.uid)) {
        // ... loading screen ...
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--background-color)', gap: '20px' }}>
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
                    style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid var(--border-global)',
                        borderTop: '4px solid var(--button-background)',
                        borderRadius: '50%'
                    }}
                />
                <p style={{ color: 'var(--text-color)', fontWeight: 600, fontSize: '1.1rem', margin: 0 }}>Carregando...</p>
            </div>
        );
    }

    // Não está logado → manda para o login do merchant (/Authentication)
    if (!user) {
        return <Navigate to="/Authentication" state={{ from: location }} replace />;
    }

    // Rota exclusiva de admin da Auuii. Este check é conveniência de navegação,
    // NÃO é a proteção: quem editar o bundle passa daqui. O que realmente barra
    // é o firestore.rules (isStaff() lê a claim `role` do ID token assinado),
    // então sem a claim as telas abrem vazias com permission-denied.
    // → 404 em vez de redirect: não confirma pra um curioso que a rota existe.
    if (requireAdmin && !isAdmin) {
        return <Navigate to="/not-found" replace />;
    }

    // Rota que exige conta de merchant, mas o usuário logado não é merchant
    // → também manda para o login/cadastro de merchant.
    // O admin passa mesmo sem doc em `merchants/`: a conta dele não é uma loja,
    // e é justamente por isso que ele precisa operar as dos outros.
    if (requireMerchant && !isMerchant && !isAdmin) {
        return <Navigate to="/Authentication" state={{ from: location, needMerchant: true }} replace />;
    }

    // Retorna a página que o usuário queria acessar depois de confirmada a sessão válida
    return children;
};

export default ProtectedRoute;
